var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      class: {
        "cw-ribbon-wrapper-consume": _vm.consumeMode,
      },
      attrs: {
        id: _vm.isContentBar ? "contentbar" : null,
      },
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.stickyRibbon,
            expression: "stickyRibbon",
          },
        ],
        staticClass: "cw-ribbon-sticky-top",
      }),
      _vm._v(" "),
      _c(
        "header",
        {
          staticClass: "cw-ribbon",
          class: {
            "cw-ribbon-sticky": _vm.stickyRibbon,
            "cw-ribbon-consume": _vm.consumeMode,
          },
          attrs: {
            id: _vm.isContentBar ? "cw-ribbon" : null,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-ribbon-wrapper-left",
            },
            [
              _c(
                "nav",
                {
                  staticClass: "cw-ribbon-nav",
                  class: _vm.buttonsClass,
                },
                [_vm._t("buttons")],
                2
              ),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "cw-ribbon-breadcrumb",
                },
                [
                  _c(
                    "ul",
                    [
                      _vm.breadcrumbFallback
                        ? _vm._t("breadcrumbFallback")
                        : _vm._t("breadcrumbList"),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cw-ribbon-wrapper-right",
            },
            [
              _vm.showToolbarButton
                ? _c("button", {
                    staticClass: "cw-ribbon-button cw-ribbon-button-menu",
                    attrs: {
                      title: _vm.textRibbon.toolbar,
                    },
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        return _vm.activeToolbar.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._t("menu"),
            ],
            2
          ),
          _vm._v(" "),
          _vm.consumeMode
            ? _c("div", {
                staticClass: "cw-ribbon-consume-bottom",
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showTools
            ? _c("courseware-ribbon-toolbar", {
                class: {
                  "cw-ribbon-tools-sticky": _vm.stickyRibbon,
                },
                style: {
                  height: _vm.toolbarHeight + "px",
                },
                attrs: {
                  toolsActive: _vm.unfold,
                  stickyRibbon: _vm.stickyRibbon,
                  canEdit: _vm.canEdit,
                },
                on: {
                  deactivate: _vm.deactivateToolbar,
                  blockAdded: function blockAdded($event) {
                    return _vm.$emit("blockAdded")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.stickyRibbon
        ? _c("div", {
            staticClass: "cw-ribbon-sticky-bottom",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stickyRibbon
        ? _c("div", {
            staticClass: "cw-ribbon-sticky-spacer",
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }